<script>
export default {
  name: 'Tab',
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isNavigation: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },
  methods: {
    setActive() {
      this.$emit('setActiveTab', this.id, this.$el);
    },
  },
};
</script>

<template>
  <span :class="[{'active': isActive}, 'tab']">
    <a v-if="!isNavigation" class="tab-link" @click="setActive">{{ title }}</a>
    <nuxt-link v-else 
               :to="url" 
               class="tab-link" 
               @click="setActive">{{ title }}</nuxt-link>
  </span>
</template>
